import { writable, readable, get } from 'svelte/store';

export const example_store = readable({
	/*
	 * Hi, I am an example of store
	 */
	name : 'hello'
});

export const project_list = writable([]);

export const show_sidebar = writable(false);

export const show_header = writable(false);

export const active_breadcrumb = writable('');

// Array of keyphrase objects with structure:
// - id: Unique identifier for the keyphrase card
// - url: The URL value
// - keyword: The keyphrase text value
// - urlref: The URL reference value as unique identifier
// - status: Validation status ("valid", "invalid", "crawl-error")
// - eg: { id: "keyphrases-1", url: "", keyword: "", urlref: "", status: "" }
export const keyphrases = writable([]);

// Array of competitor URL objects with structure:
// - id: Unique identifier for the competitor URL card
// - url: The competitor URL value
// - urlref: The URL reference value as unique identifier
// - status: Validation status ("valid", "invalid", "crawl-error")
// - eg:{ id: "competitor-1", url: "", urlref: "", status: "" }
export const competitorUrls = writable([]);

export const logged_in = writable(false);

window.stores = {
	get : get,
	example_store : example_store,
	project_list : project_list,
	show_sidebar : show_sidebar,
	show_header: show_header,
	active_breadcrumb : active_breadcrumb,
	keyphrases : keyphrases,
	competitorUrls : competitorUrls,
	logged_in : logged_in
}
